import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import taskService from '../../services/taskService';
import VendorStore from './VendorStore';
import vendorDashboardService from '../../services/vendorDashboardService';
import ContractStore from './ContractStore';

const UserVendorContractList = () => {
  const [tasks, setTasks] = useState([]);
  const [vendorData, setVendorContracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    status: '',
    priority: '',
    search: '',
    page: 1,
    limit: 20
  });
  const [pagination, setPagination] = useState({});
  const { selectedVendor, setSelectedVendor, clearSelectedVendor } = VendorStore();

   const setSelectedContract = ContractStore(
      (state) => state.setSelectedContract
    );

  useEffect(() => {
    // fetchTasks();
    fetchContracts()
  }, [filters, selectedVendor]);
  const navigate = useNavigate();
  console.log("dats===", selectedVendor)

  const fetchContracts = async () => {
    try {
      setLoading(true);
      const data = await vendorDashboardService.getContracts(selectedVendor.id);;
      setVendorContracts(data);
      console.log("vvvv===", vendorData)
      // setPagination(data.pagination || {});
      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch tasks');
      setTasks([]); // Set empty array on error
    } finally {
      setLoading(false);
    }
  };


  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      return 'Today';
    } else if (date.toDateString() === yesterday.toDateString()) {
      return 'Yesterday';
    } else {
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: date.getFullYear() !== today.getFullYear() ? 'numeric' : undefined
      });
    }
  };



  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this task?')) {
      return;
    }

    try {
      await taskService.deleteTask(id);
      // fetchTasks();
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to delete task');
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value, page: 1 }));
  };

  const getStatusBadge = (status) => {
    const statusColors = {
      'To Do': 'badge-secondary',
      'In Progress': 'badge-primary',
      'In Review': 'badge-warning',
      'Done': 'badge-success',
      'Blocked': 'badge-danger'
    };
    return statusColors[status] || 'badge-secondary';
  };

  const getPriorityBadge = (priority) => {
    const priorityColors = {
      'Low': 'badge-info',
      'Medium': 'badge-warning',
      'High': 'badge-danger',
      'Critical': 'badge-danger-dark'
    };
    return priorityColors[priority] || 'badge-secondary';
  };

  if (loading && tasks.length === 0) {
    return <div className="loading">Loading tasks...</div>;
  }

  const handleTaskClick = (id, isEdit) => {
    navigate(`/app/tasks/${id}/edit`);
    console.log("iddd", id, isEdit)
  };;


  const handleTaskEdit = (row) => {
    setSelectedContract(row);

    navigate(`/app/vendors/${row.id}/contract-edit`);

    console.log("iddd", row.id)
  };;

  const handleContractCreate = () => {
    navigate(`/app/vendors/${selectedVendor.id}/create-contract`);
  };;

  return (
    <div className="task-list-container">
      <div className="task-list-header">
        <h1>User Contracts</h1>
        <button onClick={() => handleContractCreate()} className="btn btn-primary">
          <i className="fas fa-plus"></i> Create Contract
        </button>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      <div className="filters filter-custom" >
        <div className="filter-group">
          <input
            type="text"
            name="search"
            placeholder="Search tasks..."
            value={filters.search}
            onChange={handleFilterChange}
            className="form-control filter-custom"
          />
        </div>
        <div className="filter-group">
          <select
            name="status"
            value={filters.status}
            onChange={handleFilterChange}
            className="form-control"
          >
            <option value="">All Status</option>
            <option value="To Do">To Do</option>
            <option value="In Progress">In Progress</option>
            <option value="In Review">In Review</option>
            <option value="Done">Done</option>
            <option value="Blocked">Blocked</option>
          </select>
        </div>
        <div className="filter-group">
          <select
            name="priority"
            value={filters.priority}
            onChange={handleFilterChange}
            className="form-control"
          >
            <option value="">All Priority</option>
            <option value="Low">Low</option>
            <option value="Medium">Medium</option>
            <option value="High">High</option>
            <option value="Critical">Critical</option>
          </select>
        </div>
      </div>

      <div className="task-list">
        {!vendorData || vendorData.length === 0 ? (
          <div className="no-tasks">
            <p>No contracts found</p>
            <button onClick={() => handleContractCreate()} className="btn btn-primary">
              <i className="fas fa-plus"></i> Create Contract
            </button>
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Contract Name</th>
                  <th>Type</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Renewel Date</th>
                  <th>Created By</th>
                  <th>Status</th>
                  <th>Auto Renewal</th>
                  <th>Renewal Notice Days</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {vendorData.map(task => (
                  <tr key={task.id}>

                    <td>
                      <span
                        className="task-info cursor-pointer"

                      >
                        {task.contract_name}
                      </span>
                    </td>

                    <td>
                      <span className="task-info">
                        {task.contract_type || 'Contract'}
                      </span>
                    </td>
                    <td>
                      <span className="task-info">
                        {formatDate(task.start_date || '')}
                      </span>
                    </td>
                    <td>
                      <span className="task-info">
                        {formatDate(task.end_date || '')}
                      </span>
                    </td>
                    <td>
                      <span className="task-info">
                        {formatDate(task.renewal_date || '')}
                      </span>
                    </td>
                    <td>

                      <span className="text-info">
                        {task.creator.first_name || ''} {task.creator.last_name || ''}<br></br>
                        {task.creator.email}
                      </span>

                    </td>
                    <td>
                      <span className="task-info">
                     {task.status}
                     </span>
                    </td>
                   
                    <td>
                      <span className="task-info">
                        {task.auto_renewal ? 'Yes' : 'No'}
                      </span>
                    </td>
                    <td>
                      <span className="task-info">
                        {task.renewal_notice_days}
                      </span>
                    </td>
                   
                    <td>
                      <div className="action-buttons">
                        {/* <Link
                          to={`/app/tasks/${task.id}/edit`}
                          className="btn btn-sm btn-outline-primary custom-pbtn"
                          title="Edit"
                        >
                          <i className="fas fa-edit"></i>
                        </Link> */}
                        <button
                          onClick={() => handleTaskEdit(task)}
                          className="btn btn-sm btn-outline-primary custom-pbtn"
                          title="Edit"
                        >
                          <i className="fas fa-edit custom-fas-icon"></i>
                        </button>

                        <button
                          onClick={() => handleDelete(task.id)}
                          className="btn btn-sm btn-outline-danger custom-dbtn"
                          title="Delete"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {pagination.pages > 1 && (
        <div className="pagination">
          <button
            onClick={() => setFilters(prev => ({ ...prev, page: prev.page - 1 }))}
            disabled={filters.page === 1}
            className="btn btn-outline-primary"
          >
            Previous
          </button>
          <span className="page-info">
            Page {pagination.page} of {pagination.pages}
          </span>
          <button
            onClick={() => setFilters(prev => ({ ...prev, page: prev.page + 1 }))}
            disabled={filters.page === pagination.pages}
            className="btn btn-outline-primary"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default UserVendorContractList;


